<script>
  import { onMount } from 'svelte';

  let pendingUsers = [];
  let approvedUsers = [];

  // ✅ 마운트 시 승인대기 + 승인된 사용자 모두 가져오기
  onMount(async () => {
    await loadUsers();
  });

  async function loadUsers() {
    const resPending = await fetch('/api/users/pending', { credentials: 'include' });
    if (resPending.ok) pendingUsers = await resPending.json();

    const resApproved = await fetch('/api/users/approved', { credentials: 'include' });
    if (resApproved.ok) approvedUsers = await resApproved.json();
  }

  // ✅ 승인 처리 함수
  async function approveUser(id) {
    const res = await fetch(`/api/users/approve/${id}`, { 
      method: 'POST', 
      credentials: 'include' 
    });
    if (res.ok) {
      // 승인된 사용자를 pending → approved 로 이동
      const user = pendingUsers.find(u => u.id === id);
      pendingUsers = pendingUsers.filter(u => u.id !== id);
      approvedUsers = [...approvedUsers, { ...user }];
    } else {
      alert("승인 실패");
    }
  }
</script>

<main>
  <h2><i class="bi-person-fill-add"></i> 계정 승인 관리</h2>

  <!-- ✅ 승인 대기중 사용자 -->
  <div class="card-container">
    <h3>승인 대기중</h3>
    <table>
      <thead>
        <tr>
          <th>ID</th><th>이름</th><th>부서</th><th>승인</th>
        </tr>
      </thead>
      <tbody>
        {#if pendingUsers.length > 0}
          {#each pendingUsers as u}
            <tr>
              <td>{u.id}</td>
              <td>{u.name}</td>
              <td>{u.department}</td>
              <td>
                <input type="checkbox" on:change={() => approveUser(u.id)} />
              </td>
            </tr>
          {/each}
        {:else}
          <tr><td colspan="4">승인 대기중인 사용자가 없습니다.</td></tr>
        {/if}
      </tbody>
    </table>
  </div>

  <!-- ✅ 승인된 사용자 -->
  <div class="card-container" style="margin-top:20px;">
    <h3>승인된 계정</h3>
    <table>
      <thead>
        <tr>
          <th>ID</th><th>이름</th><th>부서</th>
        </tr>
      </thead>
      <tbody>
        {#if approvedUsers.length > 0}
          {#each approvedUsers as u}
            <tr>
              <td>{u.id}</td>
              <td>{u.name}</td>
              <td>{u.department}</td>
            </tr>
          {/each}
        {:else}
          <tr><td colspan="3">승인된 사용자가 없습니다.</td></tr>
        {/if}
      </tbody>
    </table>
  </div>
</main>

<style>
  main {
    width: 100%;
    padding: 20px;
    font-family: 'Segoe UI', sans-serif;
  }

  .card-container {
    max-width: 850px;
    margin: 0 auto;
    background-color: #fcfcf8;
    border: 1px solid #cfcfca;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    padding: 24px;
    transition: transform 0.2s ease;
  }

  .card-container:hover {
    transform: translateY(-2px);
  }

  h2 {
    text-align: center;
    margin-bottom: 24px;
    font-size: 1.5rem;
    color: #444;
  }

  h3 {
    font-size: 1.2rem;
    margin-bottom: 12px;
    color: #555;
  }

  table {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    border-collapse: collapse;
    background-color: #fcfcf8;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    border-radius: 10px;
    overflow: hidden;
  }

  thead th {
    padding: 12px;
    font-size: 1rem;
    color: #333;
    border-bottom: 1px solid #ccc;
    text-align: center;
  }

  tbody td {
    padding: 12px;
    font-size: 0.95rem;
    color: #555;
    text-align: center;
    border-bottom: 1px solid #eee;
  }

  tbody tr:hover {
    background-color: #f5f5ec;
  }

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #92927b;
  }
</style>
